module.exports = __webpack_public_path__ + "img/Pulse-0.7s-200px.82beebe6.svg";